import React, { useState, useEffect } from 'react';
import { Grid, Typography, TextField, Button, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import axios from 'axios';
import { useDevice } from 'components/DeviceContext.js';
import { Card1, Card2 } from 'components/Card';

const Contato = () => {
    const { isMobile } = useDevice();
    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        mensagem: '',
        telefone: '',
        cargo: '',
        entidade: '',
        municipio: '',
        sigla_uf: '',
        email_destino: 'a.social@cnm.org.br',
        origem: 'Fia M'
    });

    const [estados, setEstados] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [enviado, setEnviado] = useState(false);

    useEffect(() => {
        // Buscar estados
        axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
            .then(response => {
                setEstados(response.data);
            })
            .catch(error => {
                console.error('Erro ao buscar estados:', error);
            });
    }, []);

    const handleEstadoChange = (e) => {
        const sigla_uf = e.target.value;
        setFormData({ ...formData, sigla_uf }); // Atualize para sigla_uf
        // Buscar municípios do estado selecionado
        axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${sigla_uf}/municipios`)
            .then(response => {
                setMunicipios(response.data);
            })
            .catch(error => {
                console.error('Erro ao buscar municípios:', error);
            });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post('https://contatos.cnm.org.br/api/faleconosco', formData)
            .then(response => {
                setEnviado(true);
                console.log('E-mail enviado com sucesso!');
                setFormData({
                    nome: '',
                    email: '',
                    mensagem: '',
                    telefone: '',
                    cargo: '',
                    entidade: '',
                    municipio: '',
                    sigla_uf: ' ',
                    email_destino: 'andiara.silva@cnm.org.br',
                    origem: 'Fia M'
                });
            })
            .catch(error => {
                console.error('Erro ao enviar dados:', error);
            });
        window.scrollTo(0, 0);
    };

    return (
        <Grid container
            style={{
                display: 'flex',
                justifyContent: 'space-around',
                flexDirection: isMobile ? 'column' : '',
                maxHeight: isMobile ? '100%' : '100%',
                fontFamily: 'Open sans',
                margin: isMobile ? '' : '2em 0 5em'
            }}>
            <Grid item xs={12} md={5} lg={5}>
                {enviado ? (
                    <Typography style={{
                        textAlign: 'center', fontSize: '1em',
                        paddingTop: '2em'
                    }}>Mensagem enviada com sucesso!</Typography>
                ) : (

                    <form onSubmit={handleSubmit} style={{
                        border: '2px solid var(--cinza)', margin: isMobile ? '1em' : '2em 0 5em',
                        padding: isMobile ? '0.8em' : '3em'
                    }}>
                        <Grid style={{ textAlign: 'center', paddingBottom: '1em' }}>
                            <h1 style={{
                                color: 'var(--azul)',
                                fontSize: isMobile ? '24px' : '32px'
                            }}>Contato</h1>
                            <p>Perguntas, sugestões e reclamações</p>
                            <p>Envie um e-mail e entraremos em contato</p>

                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="uf-label">UF*</InputLabel>
                                    <Select
                                        labelId="uf-label"
                                        id="uf"
                                        name="sigla_uf" // Corrija para sigla_uf
                                        value={formData.sigla_uf} // Corrija para formData.sigla_uf
                                        onChange={handleEstadoChange}
                                        required
                                    >
                                        <MenuItem value="">Escolha o Estado</MenuItem>
                                        {estados.map(estado => (
                                            <MenuItem key={estado.sigla} value={estado.sigla}>{estado.nome}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="municipio-label">Município*</InputLabel>
                                    <Select
                                        labelId="municipio-label"
                                        id="municipio"
                                        name="municipio"
                                        value={formData.municipio}
                                        onChange={handleChange}
                                        required
                                    >
                                        <MenuItem value="">Selecione um estado</MenuItem>
                                        {municipios.map(municipio => (
                                            <MenuItem key={municipio.id} value={municipio.nome}>{municipio.nome}</MenuItem>
                                        ))}
                                    </Select>

                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="nome"
                                    name="nome"
                                    label="Nome"
                                    value={formData.nome}
                                    onChange={handleChange}
                                    placeholder="Seu nome"
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="entidade"
                                    name="entidade"
                                    label="Órgão ou Empresa"
                                    value={formData.entidade}
                                    onChange={handleChange}
                                    placeholder="Informe o nome do órgão ou empresa"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="cargo"
                                    name="cargo"
                                    label="Cargo"
                                    value={formData.cargo}
                                    onChange={handleChange}
                                    placeholder="Informe seu cargo"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    type="email"
                                    label="E-mail"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Informe seu e-mail"
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="telefone"
                                    name="telefone"
                                    label="Telefone"
                                    value={formData.telefone}
                                    onChange={handleChange}
                                    placeholder="(00) 00000-0000"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="mensagem"
                                    name="mensagem"
                                    label="Mensagem"
                                    value={formData.mensagem}
                                    onChange={handleChange}
                                    placeholder="Digite sua mensagem"
                                    multiline
                                    minRows={4}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">ENVIAR</Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Grid>

            <Grid item xs={12} md={5} lg={4}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    alignSelf: isMobile ? 'center' : '',
                }}>
                <Card1 />
                <Card2 />

            </Grid>
        </Grid>
    );
};

export default Contato;
